<template>
  <footer style="background: #003455">
    <a href="https://www.avishkaar.cc/refunds-cancellations">
      <!-- <img
        class="d-md-block d-none"
        :src="get_img_path + '/workflow/shop/Desktop.webp'"
        alt=""
        width="100%"
      />
      <img
        class="d-md-none d-block"
        :src="get_img_path + '/workflow/shop/Mobile.webp'"
        alt=""
        width="100%"
      /> -->
      <picture>
        <source media="(min-width: 576px)" :srcset="`${get_img_path}/workflow/shop/Desktop.webp`" width="100%" height="100%" loading="lazy">
        <img :src="`${get_img_path}/workflow/shop/Mobile.webp`" alt=" Payment options, 100% satisfaction guarantee, no questions asked - 7 days refund, free shipping" width="100%" height="100%" loading="lazy">
      </picture>
    </a>
    <div style="background: #044e7c">
      <div class="container">
        <b-row class="text-left py-5">
          <b-col class="d-flex col-md-3 col-12 py-md-0 py-4">
            <div class="footer-contact">
              <svg
                width="32"
                height="25"
                viewBox="0 0 32 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M30.4 0.010534C30.2637 -0.00351133 30.1263 -0.00351133 29.99 0.010534H1.98996C1.8105 0.0132991 1.63224 0.0402073 1.45996 0.0905339L15.91 14.4805L30.4 0.010534Z"
                  fill="#F36F2E"
                />
                <path
                  d="M31.88 1.40039L17.32 15.9004C16.9453 16.2729 16.4384 16.482 15.91 16.482C15.3816 16.482 14.8747 16.2729 14.5 15.9004L0.0700001 1.51039C0.0256394 1.67343 0.00211869 1.84144 0 2.01039V22.0104C0 22.5408 0.210714 23.0495 0.585786 23.4246C0.960859 23.7997 1.46957 24.0104 2 24.0104H30C30.5304 24.0104 31.0391 23.7997 31.4142 23.4246C31.7893 23.0495 32 22.5408 32 22.0104V2.01039C31.992 1.80205 31.9516 1.59623 31.88 1.40039ZM3.37 22.0104H1.98V20.5804L9.25 13.3704L10.66 14.7804L3.37 22.0104ZM29.98 22.0104H28.58L21.29 14.7804L22.7 13.3704L29.97 20.5804L29.98 22.0104Z"
                  fill="#F36F2E"
                />
              </svg>
            </div>
            <div class="text-white my-auto ml-3">
              <p class="m-0 text-white">Email us at</p>
              <a href="mailto:support@avishkaar.cc" class="text-white">support@avishkaar.cc</a>
            </div>
          </b-col>
          <b-col class="d-flex col-md-3 col-12 py-md-0 py-4">
            <div class="footer-contact">
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.2329 8.55603C28.6982 -0.000282841 17.3981 -2.54405 8.6347 2.77474C0.101962 8.09353 -2.66541 19.6561 2.86934 28.2124L3.33057 28.9062L1.48565 35.8437L8.40409 33.9937L9.09593 34.4562C12.0939 36.075 15.3225 37 18.5511 37C22.0103 37 25.4696 36.075 28.4675 34.225C37.0003 28.6749 39.537 17.3436 34.2329 8.55603ZM29.39 26.3624C28.4675 27.7499 27.3145 28.6749 25.7002 28.9062C24.7777 28.9062 23.6246 29.3687 19.0124 27.5187C15.0919 25.6687 11.8633 22.6624 9.55716 19.1936C8.17347 17.5749 7.48163 15.4936 7.25101 13.4123C7.25101 11.5623 7.94286 9.94354 9.09593 8.78728C9.55716 8.32478 10.0184 8.09353 10.4796 8.09353H11.6327C12.0939 8.09353 12.5551 8.09353 12.7858 9.01854C13.247 10.1748 14.4001 12.9498 14.4001 13.1811C14.6307 13.4123 14.6307 13.8748 14.4001 14.1061C14.6307 14.5686 14.4001 15.0311 14.1694 15.2623C13.9388 15.4936 13.7082 15.9561 13.4776 16.1873C13.0164 16.4186 12.7858 16.8811 13.0164 17.3436C13.9388 18.7311 15.0919 20.1186 16.245 21.2749C17.6287 22.4311 19.0124 23.3561 20.6267 24.0499C21.0879 24.2812 21.5491 24.2812 21.7797 23.8186C22.0103 23.3561 23.1634 22.1999 23.6246 21.7374C24.0859 21.2749 24.3165 21.2749 24.7777 21.5061L28.4675 23.3561C28.9288 23.5874 29.39 23.8186 29.6206 24.0499C29.8512 24.7437 29.8512 25.6687 29.39 26.3624Z"
                  fill="#F36F2E"
                />
              </svg>
            </div>
            <div class="text-white my-auto ml-3">
              <p class="m-0 text-white">Whatsapp or Call us on</p>
              <a href="tel:+918506931515" class="text-white">+91-8506931515</a>
            </div>
          </b-col>
          <div class="contact-svg d-md-block d-none">
            <svg
              width="125"
              height="118"
              viewBox="0 0 125 118"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M66.2131 89.1936C55.6101 89.1936 44.8381 82.8806 38.5513 74.5248C8.38954 74.5248 7.47778 117.742 7.47778 117.742H124.941C124.941 117.742 127.309 74.333 93.3895 74.333C87.1101 82.7921 76.816 89.1936 66.2131 89.1936Z"
                fill="#18689A"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M91.4775 37.385C91.4775 49.8193 80.1614 73.5963 66.1908 73.5963C52.2422 73.5963 40.9187 49.8119 40.9187 37.385C40.9187 24.9581 52.2349 14.8691 66.1908 14.8691C80.1614 14.8765 91.4775 24.9655 91.4775 37.385Z"
                fill="#18689A"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M102.757 26.6531C102.757 24.3226 99.5217 22.442 95.507 22.4272V17.6261C95.507 16.9107 95.779 0.162109 66.279 0.162109C36.7937 0.162109 37.0658 16.9107 37.0658 17.6261V22.5969C36.9923 22.5969 36.9334 22.5747 36.8673 22.5747C32.8746 22.5747 29.6614 24.4259 29.6614 26.7195V47.0302C29.6614 49.3091 32.882 51.1676 36.8673 51.1676C40.8526 51.1676 44.0878 49.3091 44.0878 47.0302V26.7195C44.0878 26.4024 43.8893 26.1147 43.7717 25.8197V20.2811C43.7717 19.7722 41.654 7.13148 66.279 7.13148C90.9114 7.13148 88.3526 19.7722 88.3526 20.2811V26.1147C88.3084 26.2991 88.1687 26.4614 88.1687 26.6531V47.4285C88.1687 49.7664 91.4261 51.6617 95.4628 51.6617C95.5511 51.6617 95.6173 51.6322 95.7055 51.6322V59.2211H88.4702V66.3749H102.83L102.757 26.6531Z"
                fill="#18689A"
              />
            </svg>
          </div>
        </b-row>
      </div>
    </div>
    <div class="container">
      <b-row class="pt-5">
        <b-col md="6" sm="12" class="text-left">
          <div>
            <img
              :src="get_img_path + '/workflow/vue/hp/footerLogo.png'"
              alt="Avishkaar"
              loading="lazy"
            />
          </div>
          <div class="pt-md-4 pt-2">
            <a href="https://www.facebook.com/AvishkaarEdu/">
              <svg
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M35.9667 15.167H16.0334C15.554 15.167 15.1667 15.5543 15.1667 16.0337V35.967C15.1667 36.4464 15.554 36.8337 16.0334 36.8337H35.9667C36.4461 36.8337 36.8334 36.4464 36.8334 35.967V16.0337C36.8334 15.5543 36.4461 15.167 35.9667 15.167ZM33.4642 21.491H31.7336C30.3767 21.491 30.114 22.1355 30.114 23.0834V25.1716H33.3532L32.9307 28.4405H30.114V36.8337H26.7367V28.4432H23.912V25.1716H26.7367V22.7612C26.7367 19.9634 28.4457 18.4387 30.9428 18.4387C32.1399 18.4387 33.1663 18.528 33.467 18.5687V21.491H33.4642Z"
                  fill="white"
                />
              </svg>
            </a>

            <a href="https://twitter.com/AvishkaarEdu">
              <svg
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M39.0001 17.7407C38.0041 18.1638 36.9203 18.4683 35.8039 18.5869C36.9629 17.9088 37.8309 16.8375 38.245 15.5741C37.1573 16.2112 35.9658 16.658 34.7233 16.8946C34.2039 16.3479 33.5758 15.9123 32.8781 15.6151C32.1804 15.3179 31.428 15.1654 30.6677 15.167C27.5919 15.167 25.1183 17.6221 25.1183 20.635C25.1183 21.058 25.1704 21.4811 25.255 21.8882C20.6494 21.651 16.5418 19.4843 13.8111 16.167C13.3135 17.0039 13.0527 17.9568 13.0559 18.9266C13.0559 20.8241 14.0356 22.4971 15.5296 23.4811C14.6492 23.447 13.7894 23.2087 13.0201 22.7856V22.8529C13.0201 25.5099 14.9275 27.7119 17.4695 28.2183C16.9922 28.3404 16.5012 28.4028 16.0081 28.4042C15.6468 28.4042 15.305 28.3689 14.96 28.3208C15.663 30.4875 17.7103 32.0612 20.1482 32.1125C18.2409 33.5837 15.8518 34.449 13.2577 34.449C12.7923 34.449 12.3627 34.433 11.9167 34.3817C14.3774 35.9362 17.297 36.8337 20.4411 36.8337C30.6482 36.8337 36.2335 28.5067 36.2335 21.2792C36.2335 21.042 36.2335 20.8048 36.2172 20.5676C37.2978 19.7888 38.245 18.8241 39.0001 17.7407Z"
                  fill="white"
                />
              </svg>
            </a>

            <a href="https://www.youtube.com/c/avishkaar">
              <svg
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M41.5941 18.5089C41.4116 17.865 41.0637 17.2786 40.5842 16.8064C40.1047 16.3342 39.5098 15.9922 38.857 15.8135C36.4068 15.167 26.5566 15.167 26.5566 15.167C26.5566 15.167 16.725 15.1515 14.2492 15.8135C13.5975 15.993 13.0037 16.3354 12.5253 16.8075C12.0469 17.2797 11.6999 17.8657 11.5181 18.5089C11.0528 20.9844 10.8236 23.4976 10.8336 26.0154C10.829 28.521 11.0582 31.0218 11.5181 33.486C11.7005 34.1295 12.0476 34.7159 12.5258 35.189C13.0041 35.662 13.5976 36.0057 14.2492 36.1872C16.6995 36.8337 26.5566 36.8337 26.5566 36.8337C26.5566 36.8337 36.3822 36.8337 38.857 36.1872C39.5097 36.0065 40.1044 35.6631 40.5837 35.1901C41.063 34.717 41.411 34.1302 41.5941 33.486C42.0448 31.0233 42.2648 28.5188 42.2491 26.0154C42.2648 23.4954 42.0498 20.9871 41.5941 18.5089ZM23.41 30.655V21.3554L31.6093 26.0154L23.41 30.655Z"
                  fill="white"
                />
              </svg>
            </a>

            <a href="https://www.linkedin.com/company/avishkaardotcc">
              <svg
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M35.9666 15.167H16.0333C15.5539 15.167 15.1666 15.5543 15.1666 16.0337V35.967C15.1666 36.4464 15.5539 36.8337 16.0333 36.8337H35.9666C36.446 36.8337 36.8333 36.4464 36.8333 35.967V16.0337C36.8333 15.5543 36.446 15.167 35.9666 15.167ZM21.5935 33.6297H18.3787V23.2893H21.5935V33.6297ZM19.9875 21.8755C19.6189 21.8755 19.2587 21.7663 18.9522 21.5615C18.6458 21.3568 18.407 21.0657 18.266 20.7253C18.1249 20.3848 18.088 20.0101 18.1599 19.6487C18.2318 19.2872 18.4093 18.9552 18.6699 18.6946C18.9305 18.434 19.2625 18.2566 19.6239 18.1847C19.9854 18.1128 20.36 18.1497 20.7005 18.2907C21.041 18.4317 21.332 18.6706 21.5368 18.977C21.7415 19.2834 21.8508 19.6437 21.8508 20.0122C21.8481 21.0414 21.0139 21.8755 19.9875 21.8755ZM33.6293 33.6297H30.4172V28.6003C30.4172 27.4005 30.3956 25.8595 28.7462 25.8595C27.0752 25.8595 26.8179 27.1649 26.8179 28.5137V33.6297H23.6085V23.2893H26.6906V24.703H26.7339C27.1618 23.8905 28.21 23.032 29.7754 23.032C33.0308 23.032 33.6293 25.1743 33.6293 27.9584V33.6297Z"
                  fill="white"
                />
              </svg>
            </a>

            <a href="https://www.instagram.com/avishkaaredu">
              <svg
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26 15.167C23.055 15.167 22.6879 15.1812 21.5354 15.23C20.3781 15.2869 19.5953 15.4663 18.9046 15.7345C18.1817 16.0074 17.527 16.4347 16.9862 16.9865C16.4328 17.5261 16.0052 18.1812 15.7341 18.905C15.4659 19.5957 15.2865 20.3785 15.2296 21.5358C15.1775 22.689 15.1666 23.0553 15.1666 26.0003C15.1666 28.9453 15.1808 29.3124 15.2296 30.4649C15.2865 31.6188 15.4659 32.405 15.7341 33.0957C16.007 33.8186 16.4343 34.4733 16.9862 35.0141C17.5257 35.5675 18.1808 35.9951 18.9046 36.2662C19.5953 36.531 20.3815 36.7138 21.5354 36.7707C22.6886 36.8228 23.055 36.8337 26 36.8337C28.945 36.8337 29.312 36.8194 30.4645 36.7707C31.6184 36.7138 32.4046 36.5303 33.0953 36.2662C33.8182 35.9933 34.4729 35.566 35.0137 35.0141C35.5679 34.4751 35.9955 33.8199 36.2658 33.0957C36.5306 32.405 36.7134 31.6188 36.7703 30.4649C36.8225 29.3117 36.8333 28.9453 36.8333 26.0003C36.8333 23.0553 36.8191 22.6883 36.7703 21.5358C36.7134 20.3819 36.5299 19.5916 36.2658 18.905C35.9929 18.1821 35.5656 17.5274 35.0137 16.9865C34.4748 16.4324 33.8195 16.0048 33.0953 15.7345C32.4046 15.4663 31.6184 15.2869 30.4645 15.23C29.3113 15.1778 28.945 15.167 26 15.167ZM26 17.1172C28.8921 17.1172 29.2375 17.1315 30.3806 17.1802C31.4349 17.2296 32.0091 17.4057 32.3904 17.5547C32.8617 17.7287 33.2883 18.0056 33.6391 18.3653C33.9982 18.7146 34.274 19.1402 34.4463 19.6106C34.5953 19.9918 34.7713 20.5661 34.8207 21.6204C34.8695 22.7635 34.8837 23.1095 34.8837 26.001C34.8837 28.8925 34.8695 29.2385 34.8167 30.3816C34.7598 31.436 34.5837 32.0102 34.4354 32.3914C34.2303 32.9 34.0014 33.2555 33.6235 33.6401C33.2716 33.9976 32.8452 34.2731 32.3748 34.4473C31.9983 34.5963 31.4159 34.7724 30.3575 34.8218C29.2084 34.8705 28.8698 34.8848 25.9702 34.8848C23.0705 34.8848 22.7326 34.8705 21.5821 34.8177C20.5278 34.7608 19.9461 34.5848 19.5648 34.4365C19.0502 34.2313 18.6974 34.0024 18.3195 33.6246C17.9383 33.2433 17.6958 32.8804 17.5089 32.3759C17.3573 31.9994 17.1839 31.417 17.1277 30.3586C17.0891 29.223 17.0708 28.8708 17.0708 25.9848C17.0708 23.1 17.0891 22.7472 17.1277 21.5974C17.1839 20.539 17.3573 19.958 17.5089 19.5801C17.6958 19.0648 17.939 18.7126 18.3195 18.3314C18.6967 17.9542 19.0502 17.7104 19.5648 17.5195C19.9461 17.3712 20.5135 17.1951 21.572 17.1423C22.7211 17.101 23.0597 17.0861 25.9553 17.0861L26 17.1172ZM26 20.4401C25.2695 20.4398 24.5462 20.5835 23.8713 20.8629C23.1964 21.1423 22.5832 21.552 22.0667 22.0685C21.5502 22.5849 21.1406 23.1982 20.8612 23.873C20.5818 24.5479 20.4381 25.2712 20.4384 26.0017C20.4381 26.7321 20.5818 27.4554 20.8612 28.1303C21.1406 28.8052 21.5502 29.4184 22.0667 29.9349C22.5832 30.4514 23.1964 30.8611 23.8713 31.1405C24.5462 31.4199 25.2695 31.5635 26 31.5633C26.7304 31.5635 27.4537 31.4199 28.1286 31.1405C28.8035 30.8611 29.4167 30.4514 29.9332 29.9349C30.4497 29.4184 30.8593 28.8052 31.1387 28.1303C31.4181 27.4554 31.5618 26.7321 31.5615 26.0017C31.5618 25.2712 31.4181 24.5479 31.1387 23.873C30.8593 23.1982 30.4497 22.5849 29.9332 22.0685C29.4167 21.552 28.8035 21.1423 28.1286 20.8629C27.4537 20.5835 26.7304 20.4398 26 20.4401ZM26 29.613C24.0037 29.613 22.3886 27.998 22.3886 26.0017C22.3886 24.0054 24.0037 22.3903 26 22.3903C27.9963 22.3903 29.6113 24.0054 29.6113 26.0017C29.6113 27.998 27.9963 29.613 26 29.613ZM33.0858 20.218C33.0855 20.5631 32.9481 20.894 32.704 21.1379C32.4598 21.3818 32.1288 21.5188 31.7837 21.5188C31.613 21.5188 31.444 21.4852 31.2864 21.4199C31.1287 21.3546 30.9854 21.2589 30.8648 21.1382C30.7441 21.0175 30.6484 20.8743 30.5831 20.7166C30.5178 20.559 30.4842 20.39 30.4842 20.2193C30.4842 20.0487 30.5178 19.8797 30.5831 19.7221C30.6484 19.5644 30.7441 19.4211 30.8648 19.3005C30.9854 19.1798 31.1287 19.0841 31.2864 19.0188C31.444 18.9535 31.613 18.9199 31.7837 18.9199C32.4994 18.9199 33.0858 19.5022 33.0858 20.218Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </b-col>
        <b-col md="6" sm="12" class="text-left pt-md-0 pt-4">
          <p class="text-white m-0" style="font-weight: 600; font-size: 24px">
            Subscribe to Avishkaar
          </p>
          <p class="text-white" style="font-size: 18px">
            Stay updated on the latest products, projects & more!
          </p>
          <form action="" class="subscribe-form ml-md-1 d-flex">
            <input type="email" name="" id="" />
            <button class="ab-btn">Subscribe</button>
          </form>
        </b-col>
      </b-row>
      <b-row class="py-md-5 py-4 footer-table">
        <b-col md="4" lg="2" class="text-left col-6">
          <p class="text-white link-head">Avishkaar</p>
          <div class="mb-1">
            <a class="footer-link" href="https://shop.avishkaar.cc/">Shop</a>
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/challenges'"
              >Challenges</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/projects'"
              >Projects</a
            >
          </div>
          <div class="mb-1">
            <a
              class="footer-link"
              :href="get_web_path + '/avishkaar-learning-programs'"
              >School Clubs</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/atal-tinkering-labs'"
              >ATL</a
            >
          </div>
        </b-col>
        <b-col md="4" lg="2" class="text-left col-6">
          <p class="text-white link-head mb-2">About</p>
          <div class="mb-1 mt-3">
            <router-link class="footer-link" to="/about-us"
              >About Us</router-link>
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/press'">News</a>
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/our-team'"
              >Our Team</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/community'"
              >Community</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/schools'">Schools</a>
          </div>
        </b-col>
        <b-col md="4" lg="2" class="text-left col-6">
          <p class="text-white link-head mb-2">Resources</p>
          <div class="mb-1">
            <router-link class="footer-link" to='/downloads'
              >Software</router-link
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/learn'">Learn</a>
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/trainings'"
              >Trainings</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/blogs'">Blog</a>
          </div>
        </b-col>
        <b-col md="4" lg="2" class="text-left col-6">
          <p class="text-white link-head mb-2">Events</p>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/events/makeathon'"
              >Makeathon</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" href="https://www.ircleague.com">IRC</a>
          </div>
        </b-col>
        <b-col md="4" lg="2" class="text-left col-6">
          <p class="text-white link-head mb-2">Support</p>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/feedback'"
              >Report a Feedback</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/feedback/products'"
              >Service Request</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/product/register'"
              >Register Product</a
            >
          </div>
          <div class="mb-1">
            <a class="footer-link" :href="get_web_path + '/contact-us'"
              >Contact Us</a
            >
          </div>
        </b-col>
        <b-col md="4" lg="2" class="text-left col-6">
          <p class="text-white link-head mb-2">Partner with Us</p>
          <div class="mb-1">
            <a
              class="footer-link"
              :href="get_web_path + '/become-avishkaar-trainer'"
              >Become a Trainer</a
            >
          </div>
          <div class="mb-1">
            <a
              class="footer-link"
              :href="get_web_path + '/become-channel-partner'"
              >Become a Channel Partner</a
            >
          </div>
          <div class="mb-1">
            <a
              class="footer-link"
              :href="get_web_path + '/become-avishkaar-school'"
              >Become an Avishkaar School</a
            >
          </div>
        </b-col>
      </b-row>
    </div>
    <FooterTnc />
  </footer>
</template>

<script>
import FooterTnc from "@/components/FooterTnc";

export default {
  name: "Footer",
  components: {
    FooterTnc,
  },
  data() {
    return {
      get_web_path: process.env.VUE_APP_SITE_URL,
      get_img_path: process.env.VUE_APP_IMAGE_URL,
    };
  },
};
</script>
<style scoped>
.subscribe-form button {
  border-radius: 0px 35.0769px 35.0769px 0px;
}
@media only screen and (max-width: 434px) {
  .subscribe-form button {
  width: 35%;
  padding-left: 25px;
}
  }
.subscribe-form input,
.subscribe-form input:focus {
  background: white;
  border-radius: 35.0769px 0px 0px 35.0769px;
  padding: 10px 30px;
  border: 1px solid white;
  outline: none;
}
@media only screen and (max-width: 780px) {
  .subscribe-form input,
  .subscribe-form input:focus {
    padding: 10px 1px;
  }
}
.footer-contact {
  background: white;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contact-svg {
  position: absolute;
  right: 15%;
  margin-top: -10px;
}
.footer-link {
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
.link-head {
  font-weight: 600;
  font-size: 18px;
  font-family: Poppins;
}
footer {
  margin: 0 !important;
}
/* .carousel-control-next,
.carousel-control-prev {
} */
@media screen and (max-width: 768px) {
  .footer-table > * {
    margin-bottom: 10px;
  }
}
</style>
